import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Composants graphiques
import { UITabsComponent } from './components/ui-tabs.component';
import { UITabItemComponent } from './components/ui-tab-item.component';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
	],
	providers: [
	],
	declarations: [
		UITabsComponent,
		UITabItemComponent
	],
	exports: [
		UITabsComponent,
		UITabItemComponent
	]
})
export class TabsModule {
	constructor() { }
}